import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SuccessComponent } from '../shared/modals/success/success.component';
import { ErrorComponent } from '../shared/modals/error/error.component';
import { ResponseComponent } from '../shared/modals/response/response.component';
import { LoadingSpinnerComponent } from '../shared/modals/loading-spinner/loading-spinner.component';
import { CameraComponent } from '../shared/modals/camera/camera.component';
import { SignaturePadComponent } from '../shared/modals/signature-pad/signature-pad.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VoucherDetailsComponent } from '../shared/modals/voucher-details/voucher-details.component';
import { SelectPaymentMethodComponent } from '../shared/modals/select-payment-method/select-payment-method.component';
// import { AddVestComponent } from '../shared/modals/add-vest/add-vest.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  modalRefSucess!: BsModalRef;
  modalRefError!: BsModalRef;
  modalRefResponse!: BsModalRef;
  modalRefLoadingSpinner!: BsModalRef;
  modalRefUpdateApplicationStatus!: BsModalRef;
  modalRefUpdatePreEnlistmentStatus!: BsModalRef;
  modalRefStudentFilter!: BsModalRef;
  modalRefAssignStudentScheduleConfirm!: BsModalRef;
  modalRefSelection!: BsModalRef;
  modalRefCreateScheduleDetailsConfirm!: BsModalRef;
  modalRefCreateEmployee: BsModalRef;
  modalRefVerifyMaster: BsModalRef;
  modalRefConfirmTransmit: BsModalRef;
  modalRefCamera!: BsModalRef;
  modalRefSignaturePad!: BsModalRef;
  modalRefDuplicateList!: BsModalRef;
  modalRefUpdateSector!: BsModalRef;
  modalRefDuplicateProfile!: BsModalRef;
  modalRefAddNewDemographics!: BsModalRef;
  modalRefViewDemographics!: BsModalRef;
  modalRefPrintSearch!: BsModalRef;
  modalRefTermsAndCondition!: BsModalRef;
  modalRefCreateVoucher!: MatDialogRef<any>;
  modalRefCreateAid!: MatDialogRef<any>;
  modalRefTransferHistory!: MatDialogRef<any>;
  modalRefUpdateApplicantStatus!: MatDialogRef<any>;
  modalRefUpdateUserStatus!: MatDialogRef<any>;
  modalRefChangePassword!: BsModalRef;

  modalRefVoucherDetails!: BsModalRef;
  modalRefSelectPaymentMethod!: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private dialog: MatDialog,
  ) { }


  successModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered success-modal'
    }

    return this.modalRefSucess = this.modalService.show(SuccessComponent, config);
  }

  hideSuccessModal() {
    if (this.modalRefSucess) {
      this.modalRefSucess.hide();
    }
  }

  voucherDetails(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered custom-width voucher-details'
    }

    return this.modalRefVoucherDetails = this.modalService.show(VoucherDetailsComponent, config);
  }

  hideVoucherDetails() {
    if (this.modalRefVoucherDetails) {
      this.modalRefVoucherDetails.hide();
    }
  }

  selectPaymentMethod(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered custom-width voucher-details'
    }

    return this.modalRefSelectPaymentMethod = this.modalService.show(SelectPaymentMethodComponent, config);
  }

  hideSelectPaymentMethod() {
    if (this.modalRefSelectPaymentMethod) {
      this.modalRefSelectPaymentMethod.hide();
    }
  }

  errorModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal modal-dialog-centered success-modal'
    }

    return this.modalRefError = this.modalService.show(ErrorComponent, config);
  }

  hideErrorModal() {
    if (this.modalRefError) {
      this.modalRefError.hide();
    }
  }

  openResponseModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered response-modal'
    }

    return this.modalRefSucess = this.modalService.show(ResponseComponent, config);
  }

  hideResponseModal() {
    if (this.modalRefSucess) {
      this.modalRefSucess.hide();
    }
  }

  showLoadingSpinner() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered loading-spinner'
    }

    return this.modalRefLoadingSpinner = this.modalService.show(LoadingSpinnerComponent, config);
  }

  hideLoadingSpinner() {
    if (this.modalRefLoadingSpinner) {
      this.modalRefLoadingSpinner.hide();
    }
  }

  hideConfirmTransmit(): void {
    if (this.modalRefConfirmTransmit) {
      this.modalRefConfirmTransmit.hide();
    }
  }

  showCameraModal() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal modal-dialog-centered create-employee custom-width'
    }

    return this.modalRefCamera = this.modalService.show(CameraComponent, config);
  }

  hideCameraModal(): void {
    if (this.modalRefCamera) {
      this.modalRefCamera.hide();
    }
  }

  showSignaturePad() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal modal-dialog-centered custom-width '
    }

    return this.modalRefCamera = this.modalService.show(SignaturePadComponent, config);
  }

  hideSignaturePad(): void {
    if (this.modalRefCamera) {
      this.modalRefCamera.hide();
    }
  }
}
